// extracted by mini-css-extract-plugin
export default {"authForm":"Auth_authForm__tG0TS","formBody":"Auth_formBody__mgBsi","formGroup":"Auth_formGroup__UQPV-","button":"Auth_button__eJxHX"};